import React from "react";

export function MenuIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 512 512" fill="#4B4B4B" xmlns="http://www.w3.org/2000/svg">
            <rect y="16" className="st0" width="512" height="80"></rect>
            <rect y="216.008" className="st0" width="512" height="79.984"></rect>
            <rect y="416" className="st0" width="512" height="80"></rect>
        </svg>
    );
}